var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('h1',[_vm._v("Submission progress")]),_c('ResponsiveTable',{ref:"table",attrs:{"headers":['User', 'Group', 'Submitted', 'Graded', 'Score', ''],"rows":_vm.submissions,"pages":_vm.pages},on:{"page":_vm.updateSubmissions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }